<!-- eslint-disable no-console -->
<template>
  <FormContainer :type="1" :title="title">
    <div class="title title-1">AILD-未来创意设计提交的初赛作品</div>
    <div class="title title-2">未晋级复赛</div>
    <div class="title title-3">感谢您对全国青少年劳动技能与智能设计大赛(简称AILD)未来创意设计赛项支持，希望孩子再接再励，在下次比赛中取得优异成绩。</div>
  </FormContainer>
</template>
<script>
import FormContainer from './form-container.vue'
export default {
  components: {
    FormContainer
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    data: {
      type: Array,
      default: () => []
    },
    info: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
  }),
  methods: {
  },
}
</script>
<style lang="less" scoped>
.title {
  text-align: center;
  width: 604px;
  margin: 0 auto;
  &-1 {
    color: rgba(14, 30, 80, 0.3);
    font-size: 16px;
    margin-top: 76px;
  }
  &-2 {
    margin-top: 18px;
    // color: #0152D0;
    color: rgba(3, 145, 43, 1);
    font-size: 36px;
    font-weight: 500;
  }
  &-3 {
    color: rgba(14, 30, 80, 0.5);
    font-size: 17px;
    font-weight: 400;
    margin-top: 60px;
  }

}
</style>